import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { EnkaHeader } from "@/components/EnkaHeader";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { api, TOKEN_KEY } from "@/lib/api";
import { useAdmin } from "@/lib/adminContext";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { refresh } = useAdmin();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { username, password });
      localStorage.setItem(TOKEN_KEY, data.token);
      await refresh();
      toast.success(`Welcome, ${data.display}`);
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col" data-testid="admin-login-page">
      <EnkaHeader subtitle="IQ3B9 Admin Panel" compact />
      <main className="flex-1 flex items-center justify-center px-5 py-10">
        <Card className="w-full max-w-md p-7">
          <div className="flex items-center gap-3 mb-5">
            <div className="h-10 w-10 rounded-lg bg-[color:var(--enka-blue-50)] text-[color:var(--enka-blue)] flex items-center justify-center">
              <Lock className="h-5 w-5" />
            </div>
            <div>
              <h1 className="font-display text-xl text-[color:var(--enka-ink)]">Admin Login</h1>
              <p className="text-xs text-[color:var(--enka-muted)]">IQ3B9 management console</p>
            </div>
          </div>
          <form className="space-y-4" onSubmit={submit}>
            <div>
              <Label htmlFor="username" className="text-[color:var(--enka-ink)]">Username</Label>
              <Input
                id="username"
                data-testid="admin-login-username"
                autoFocus
                autoComplete="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-[color:var(--enka-ink)]">Password</Label>
              <Input
                id="password"
                data-testid="admin-login-password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full h-11 bg-[color:var(--enka-blue)] hover:bg-[color:var(--enka-blue-600)] text-white"
              data-testid="admin-login-submit-btn"
            >
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign in"}
            </Button>
          </form>
        </Card>
      </main>
    </div>
  );
}
